import jwtAuthAxios from "../auth/jwtAuth";

const getTransactionDetail = async (param)=>{
      let response=  await jwtAuthAxios.get(`transation?${param}`)
            // console.log(response.data.data);
            if(response.data.status =='success'){
                return response.data.data
            } else{
                return []
            }
}
export default getTransactionDetail;